<template>
    <div class="lb-video-container is-centered">
        <vue-plyr>
            <div class="plyr__video-embed">
                <iframe
                    :src="`https://www.youtube.com/embed/${getIDFromYoutubeURL(
                        video
                    )}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                />
            </div>
        </vue-plyr>
    </div>
</template>

<script>
import { getIDFromYoutubeURL } from '@/lib/helpers';
export default {
    props: {
        video: {
            type: String,
            default: undefined,
        },
    },
    methods: {
        getIDFromYoutubeURL,
    },
};
</script>

<style scoped>
.lb-video-container {
    max-width: 640px;
}
</style>
